import React from 'react';
import SourceSelector from './SourceSelector';

interface Props {
  placeholderText?: string;
  onChange: (value: any) => void;
  value: string;
  isSourceCollapsed?: boolean;
  isCsvSource?: boolean;
}

function Container({ placeholderText, onChange, value, isSourceCollapsed, isCsvSource }: Props) {
  return (
    <SourceSelector
      placeholderText={placeholderText}
      onChange={onChange}
      value={value}
      isSourceCollapsed={isSourceCollapsed}
      isCsvSource={isCsvSource}
    />
  );
}

export default Container;
